import { scrollToAnchor } from '../utils/scrollToAnchor';
import portrait from '../assets/img/portrait.jpg';
import Contact from '../components/Contact';
import { CAREER, EDUCATION, INTERESTS, LEARNING, PROFILE, PROJECTS } from '../constants/content';

const Home = () => (
  <>
    <a className="skip-link" href="#main">Skip to content</a>
    <div className="site-shell" id="top">
      <header className="site-header">
        <a className="wordmark" href="#top" onClick={scrollToAnchor}>Jasmine Zeng</a>
        <nav aria-label="Main navigation" onClick={scrollToAnchor}>
          <a href="#career">Career</a>
          <a href="#projects">Projects</a>
          <a href="#education">Education</a>
          <a href="#interests">Beyond work</a>
          <a href="#contact">Contact</a>
        </nav>
      </header>
      <main id="main" tabIndex={-1}>
        <section className="intro" aria-labelledby="intro-title">
          <div>
            <p className="intro-meta">{PROFILE.title} · {PROFILE.location}</p>
            <h1 id="intro-title">Hi, I'm Jasmine</h1>
            <p className="intro-copy">{PROFILE.introduction}</p>
            <div className="skills" aria-label="Core technologies">
              {PROFILE.skills.map((skill) => <span key={skill}>{skill}</span>)}
            </div>
          </div>
          <figure className="portrait">
            <img src={portrait} alt="Jasmine Zeng" width="750" height="1000" />
          </figure>
        </section>
        <section className="content-section" id="career" aria-labelledby="career-title">
          <div className="section-heading">
            <p className="eyebrow">01 / Career</p>
            <h2 id="career-title">The path so far</h2>
            <p>From a personal project to building software professionally.</p>
          </div>
          <ol className="timeline">
            {CAREER.map((entry) => (
              <li key={entry.company}>
                <div className="timeline-date">
                  <time dateTime={entry.start}>{entry.period.split(' — ')[0]}</time>
                  {entry.period.includes(' — ') && <> — {entry.end ? <time dateTime={entry.end}>{entry.period.split(' — ')[1]}</time> : 'Present'}</>}
                </div>
                <div className="timeline-content">
                  <h3>{entry.role}</h3>
                  <p className="company">{entry.company} · {entry.location}</p>
                  <p>{entry.description}</p>
                  <p className="technology-line">{entry.technologies}</p>
                </div>
              </li>
            ))}
          </ol>
        </section>
        <section className="content-section" id="projects" aria-labelledby="projects-title">
          <div className="section-heading">
            <p className="eyebrow">02 / Personal projects</p>
            <h2 id="projects-title">Built out of curiosity</h2>
            <p>Small things that solve a problem or make room for an interest.</p>
          </div>
          <div className="project-list">
            {PROJECTS.map((project) => (
              <article className="project" key={project.name}>
                <p className="eyebrow">{project.category}</p>
                <h3>{project.name}</h3>
                <p>{project.description}</p>
                <p className="technology-line">{project.technologies}</p>
                <a href={project.href} target="_blank" rel="noreferrer">{project.linkText} <span aria-hidden="true">↗</span><span className="sr-only"> (opens in a new tab)</span></a>
              </article>
            ))}
          </div>
        </section>
        <section className="content-section" id="education" aria-labelledby="education-title">
          <div className="section-heading">
            <p className="eyebrow">03 / Education</p>
            <h2 id="education-title">Education & learning</h2>
          </div>
          <ol className="timeline education-list">
            <li className="learning-note">
              <p className="timeline-date">Now</p>
              <div className="timeline-content">
                <h3>{LEARNING.title}</h3>
                <p>{LEARNING.description}</p>
              </div>
            </li>
            {EDUCATION.map((entry) => (
              <li key={entry.institution}>
                <p className="timeline-date">{entry.period}</p>
                <div className="timeline-content">
                  <h3>{entry.qualification}</h3>
                  <p className="company">{entry.institution}</p>
                  {entry.description && <p>{entry.description}</p>}
                </div>
              </li>
            ))}
          </ol>
        </section>
        <section className="content-section interests-section" id="interests" aria-labelledby="interests-title">
          <div className="section-heading">
            <p className="eyebrow">04 / Beyond work</p>
            <h2 id="interests-title">Away from the keyboard</h2>
          </div>
          <div className="interests">
            {INTERESTS.map((interest) => (
              <div key={interest.name}>
                <h3>{interest.name}</h3>
                <p>{interest.description}</p>
              </div>
            ))}
          </div>
        </section>
        <Contact />
      </main>
    </div>
  </>
);

export default Home;